module.exports = __webpack_public_path__ + "static/media/react-bootstrap.ef194ddf.svg";